import React, { useId, useState } from 'react';

export function FAQItem({ q, a, index, testIdPrefix = 'faq' }) {
  const [open, setOpen] = useState(index === 0);
  const id = useId();
  return (
    <div className={`relative transition-colors duration-500 ${open ? 'bg-white/[0.02]' : ''}`}>
      <button
        type="button"
        data-testid={`${testIdPrefix}-${index}`}
        onClick={() => setOpen((s) => !s)}
        aria-expanded={open}
        aria-controls={id}
        className="w-full text-left py-7 grid grid-cols-[56px_1fr_44px] md:grid-cols-[96px_1fr_48px] gap-4 items-center group"
      >
        <span className="nd-mono tabular-nums">{String(index + 1).padStart(2, '0')}</span>
        <span className="font-display text-xl md:text-2xl font-semibold tracking-[-0.025em] leading-snug transition-transform duration-500 [transition-timing-function:var(--ease-out)] group-hover:translate-x-2">
          {q}
        </span>
        <span
          aria-hidden
          className={`h-11 w-11 rounded-full border grid place-items-center transition-[background-color,border-color,color,transform] duration-500 [transition-timing-function:var(--ease-out)] ${
            open ? 'bg-white text-ink-bg border-white rotate-45' : 'border-white/15 text-white'
          }`}
        >
          <svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M8 2v12M2 8h12" /></svg>
        </span>
      </button>
      <div
        id={id}
        className="grid transition-[grid-template-rows] duration-500 [transition-timing-function:var(--ease-out)]"
        style={{ gridTemplateRows: open ? '1fr' : '0fr' }}
      >
        <div className="overflow-hidden">
          <div className="grid grid-cols-[56px_1fr_44px] md:grid-cols-[96px_1fr_48px] gap-4 pb-8">
            <span />
            <p className="text-ink-muted leading-relaxed max-w-2xl text-[16px]">{a}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export function FAQList({ items, testIdPrefix = 'faq' }) {
  return (
    <div className="divide-y divide-white/[0.08] border-y border-white/[0.08]">
      {items.map((it, i) => (
        <FAQItem key={it.q} q={it.q} a={it.a} index={i} testIdPrefix={testIdPrefix} />
      ))}
    </div>
  );
}
